import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {Http, HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';

import { AbsUtilitiesModule } from '../abs-utilities/abs-utilities.module';

import { AbsFlyoutComponent } from './abs-flyout.component';
import {AbsFlyoutToggleDirective} from './abs-flyout-toggle.directive';
import {AbsDomHelperService} from '../abs-utilities/abs-dom-helper.service';

@NgModule({
  imports: [CommonModule, FormsModule, HttpModule, AbsUtilitiesModule],
  declarations: [AbsFlyoutComponent, AbsFlyoutToggleDirective],
  exports: [AbsFlyoutComponent, AbsFlyoutToggleDirective, AbsUtilitiesModule],
  providers: [AbsDomHelperService],
})
export class AbsFlyoutModule { }
